import { WALLET_CURRENCY_SYMBOLS } from 'constants/wallet';

// The "All" tab has no status query param — the API returns every status when omitted.
export const statusForTab = tabKey => (tabKey === 'all' ? undefined : tabKey);

// The Actions column (and its Review button) is shown for the Pending and All tabs only.
export const tabShowsActions = tabKey => tabKey === 'pending' || tabKey === 'all';

// Wire Transfer amounts are integer minor units (pence/cents) in the transfer's own currency.
export const formatAmount = (amountMinor, currency) => {
  if (amountMinor === null || amountMinor === undefined || Number.isNaN(Number(amountMinor))) {
    return '';
  }
  const symbol = WALLET_CURRENCY_SYMBOLS[String(currency ?? '').toLowerCase()] ?? '';
  const major = Number(amountMinor) / 100;
  const sign = major < 0 ? '-' : '';
  return `${sign}${symbol}${Math.abs(major).toFixed(2)}`;
};

export const mapWireTransferToFundingRequest = item => ({
  id: item.transferId,
  account: item.corporateClientName,
  corporateClientId: item.corporateClientId,
  transactionId: item.transferId,
  date: item.date,
  amount: formatAmount(item.amount, item.currency),
  // Raw values for analytics; `amount` above is the display string
  amountMinor: item.amount,
  currency: item.currency,
  proofOfPayment: item.fileName,
  transferReference: item.reference,
  status: item.status,
  proofStatus: item.proofStatus,
});

export const isProofValidated = proofStatus =>
  String(proofStatus ?? '').toLowerCase() === 'validated';

// The Pending tab only shows requests whose proof of payment has been validated —
// ones still awaiting an upload/review aren't ready for a funding decision yet.
export const filterRequestsForTab = (requests, tabKey) =>
  tabKey === 'pending'
    ? requests.filter(request => isProofValidated(request.proofStatus))
    : requests;

export const createOrderString = (field, order) => {
  const SORT_OPTIONS = { ascend: 'Asc', descend: 'Desc' };
  return field && order ? `${field} ${SORT_OPTIONS[order]}` : null;
};

export const saveProofOfPaymentFile = (data, fileName) => {
  if (!data) return;

  const blob = new Blob([data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();

  URL.revokeObjectURL(url);
};
